import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { getAllUnopenedBoosters } from "../services/TransactionServices";
import { useAuth } from "./AuthProvider";

interface OpenBoosterContextType {
  boostersId: string[];
  setBoostersId: React.Dispatch<React.SetStateAction<string[]>>;
}

const OpenBoosterContext = createContext<OpenBoosterContextType | undefined>(
  undefined
);

export const OpenBoosterProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [boostersId, setBoostersId] = useState<string[]>([]);
  const { user } = useAuth();

  const fetch = async () => {
    try {
      const result = await getAllUnopenedBoosters();
      setBoostersId(result);
    } catch (error) {
      console.error("Error fetching boosters to open :", error);
    }
  };

  useEffect(() => {
    if (user) fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OpenBoosterContext.Provider
      value={{
        boostersId,
        setBoostersId,
      }}
    >
      {children}
    </OpenBoosterContext.Provider>
  );
};

export const useOpenBoosterContext = (): OpenBoosterContextType => {
  const context = useContext(OpenBoosterContext);
  if (!context) {
    throw new Error("useOpenBooster must be used within a OpenBoosterProvider");
  }
  return context;
};
